module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-21-148dcfcf6f25f2241f8b0fb7c83fad88.svg";